var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content white large-padding scrollnav",attrs:{"id":"manuslist-generator"}},[_c('TheEmptyList',{attrs:{"title":'Statistikk',"message":'Velg type av statistikk i listan til venstre...',"large":false,"icon":'button-glyph-spreadsheet'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db5e7ef2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Reports/Stats/StatsEmpty.vue
// module id = null
// module chunks = 